import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6fa9825c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fa9825c')) {
      api.createRecord('6fa9825c', component.options)
    } else {
      api.reload('6fa9825c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6fa9825c&", function () {
      api.rerender('6fa9825c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/layout/index.vue"
export default component.exports